import { render, staticRenderFns } from "./VaccinationList.vue?vue&type=template&id=70e82415&scoped=true&"
import script from "./VaccinationList.vue?vue&type=script&lang=js&"
export * from "./VaccinationList.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationList.vue?vue&type=style&index=0&id=70e82415&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e82415",
  null
  
)

export default component.exports